<template>
  <div
    tabindex="-1"
    role="dialog"
    class="modal-side-drawer-filters fade fixed-end op"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Advanced Search</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true"><i class="far fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" v-if="__initialized">
          <div class="data-filters">
            <div class="row mb-3">
              <div class="col-4 col-lg-4">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input type="text" class="form-control" :value="filters.search" @input="updateSearch"/>
                </div>
              </div>

              <div class="col"></div>

              <div class="col-4 col-lg-4">
                <label>Sort</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-sort-amount-down"></i>
                  </span>

                  <multiselect
                    :options="sortByOptions"
                    :show-labels="false"
                    :allow-empty="false"
                    placeholder
                    v-model="sortBy"
                    label="name"
                  />
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-12 col-lg-3">
                <label>Stage</label>
                <multiselect
                  label="name"
                  :options="stageOptions"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="stageSelected"
                />
              </div>
              <div class="col-6 col-lg-3">
                <label>Status</label>

                <multiselect
                  :options="statusOptions"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="statusSelected"
                  label="name"
                />
              </div>
              <div class="col-6 col-lg-3">
                <label>User</label>

                <multiselect
                  :options="users"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="userSelected"
                  label="name"
                />
              </div>

              <div class="col-6 col-lg-3">
                <label>Client</label>

                <multiselect
                  :options="clients"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="clientSelected"
                  label="company"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null,
        stage: null,
        status: null,
        user: null,
        client: null,
        sort: 'updated,desc'
      },
      sortByOptions: [
        { name: 'Newest First', key: 'created', order: 'desc' },
        { name: 'Oldest First', key: 'created', order: 'asc' },
        { name: 'Last Updates', key: 'updated', order: 'desc' },
        { name: 'A-Z', key: 'name', order: 'asc' },
        { name: 'Z-A', key: 'name', order: 'desc' }
      ],
      statusOptions: [
        { name: 'Approved', key: 'Approved'},
        { name: 'Archived', key: 'Archived'},
        { name: 'Draft', key: 'Draft'},
        { name: 'Expired', key: 'Expired'},
        { name: 'Pending Approval', key: 'Pending Approval'},
        { name: 'Sent', key: 'Sent'},
        { name: 'Signed', key: 'Signed'},
        { name: 'Viewed', key: 'Viewed'},
        { name: 'Withdrawn', key: 'Withdrawn'},
      ],
      stageOptions: [
        { name: 'Stage 1', key: 'Stage 1'},
        { name: 'Stage 2', key: 'Stage 2'},
        { name: 'Stage 1&2', key: 'Stage 1 & 2'},
        { name: 'Stage 3', key: 'Stage 3'},
        { name: 'Variation', key: 'Variation'},
        { name: 'T&M', key: 'T&M'},
        { name: 'Full Budget', key: 'Full Budget'},
        { name: 'Consult', key: 'Consult'},
        { name: 'Template', key: 'Template'},
      ]
    }
  },

  computed: {
    ...mapState("users", ["users"]),
    ...mapState('clientsList', ['clients']),

    sortBy: {
      get () {
        const { filters, sortByOptions } = this

        return sortByOptions.find(({ order, key }) => filters.sort === `${key},${order}`)
      },

      set ({ key, order }) {
        this.filters.sort = `${key},${order}`
      }
    },

    stageSelected: {
      get () {
        return this.stageOptions.find(({ key }) => key === this.filters.stage)
      },

      set (value) {
        this.filters.stage = value ? value.key : null
      }
    },

    statusSelected: {
      get () {
        return this.statusOptions.find(({ key }) => key === this.filters.status)
      },

      set (value) {
        this.filters.status = value ? value.key : null
      }
    },

    userSelected: {
      get () {
        return this.users.find(({ id }) => id === parseInt(this.filters.user) )
      },

      set (value) {
        this.filters.user = value ? value.id : null
      }
    },

    clientSelected: {
      get () {
        return this.clients.find(({ id }) => id === parseInt(this.filters.client) )
      },

      set (value) {
        this.filters.client = value ? value.id : null
      }
    }
  },

  methods: {
    ...mapActions("users", ["getUsers"]),

    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  },

  created () {
    this.getUsers();
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
